<template>
  <div class="home_vue_comp" id="home_vue_comp">
    <auth></auth>
    <template>
      <div class="text-center mt-3">
        <v-dialog v-model="dialog2" style="width: 90%" dark>
          <v-card>
            <v-card-title class="text-h5 grey darken-1">
              Forms Found <v-spacer></v-spacer>
              <small
                class="pa-2"
                @click="dialog2 = false"
                style="font-size: 22px; cursor: pointer"
                >X</small
              >
            </v-card-title>

            <v-card-text class="grey darken-2" id="rslt_card">
              <files
                :files_update="files_update"
                :folder_name="folder_name"
                :lst_files="lst_files"
              ></files>
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" text @click="dialog2 = false"> Close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <template>
      <div class="text-center">
        <v-dialog v-model="dialog" width="500" dark>
          <v-card>
            <v-card-title class="text-h5 grey darken-4">
              Help on Search
            </v-card-title>

            <v-card-text class="grey darken-2">
              <br /><br />
              To enter a date range, use this format: "07/01/2025-07/15/2025".
              Note: This format has no spaces, one hyphen, and dates and months
              are expressed as two digits.
              <br /><br />
              Other search terms should be comma delimited. Each term
              individually will be matched against form names, titles and
              keywords.
              <br /><br />
              Note: Entering no search term will return all forms, which could
              take several minutes.
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="white" text @click="dialog = false"> Close </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
    <v-main id="home_main">
      <v-container
        fluid
        id="home-container"
        class="grey darken-2 ma-0 pa-1 ml-2"
      >
        <v-row
          align="center"
          dense
          no-gutters
          class="ma-0 mt-10 pa-0 grey darken-3"
        >
          <v-col cols="10" md="11">
            <v-text-field
              class="pt-0"
              v-model="sterm"
              label="Search All Forms"
              clearable
              dense
              outlined
              color="white"
              @keyup.enter="search"
              hide-details="auto"
              append-icon="$search"
              @click:append="search"
            >
            </v-text-field>
          </v-col>
          <v-col cols="auto">
            <v-btn
              @click="show_help_now"
              small
              color="blue"
              class="ma-0 pa-0 ml-2"
              ><img width="24px" src="/info.svg"
            /></v-btn>
          </v-col>
        </v-row>
      </v-container>

      <v-container>
        <!-- Folder List -->
        <folder_list></folder_list>
      </v-container>
    </v-main>
  </div>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* 0 media q */

@media (min-width: 0px) {
  #home-container {
    height: auto;
  }

  .sort-btns {
    width: 20%;
    height: 36px;
  }

  .alice {
    color: aliceblue;
  }

  .log-header .v-btn {
    background-color: #fc5c5c;
  }

  .section1 h1 {
    text-shadow: 2px 2px 4px #000000;
  }

  .training-table .v-data-table {
    border: 1px solid darkslateblue;
  }

  .training-table .v-btn__content {
    visibility: hidden !important;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  .section1 {
    justify-content: center;
    width: 100%;
  }
}

/* 1025 media q */
@media (min-width: 1025px) {
  .section1 {
    justify-content: flex-start;
    width: 100%;
  }
}

/* 2048 media q */
@media (min-width: 2048px) {
}
::v-deeo.v-dialog:not(.v-dialog--fullscreen) {
  max-height: 90%;
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
// import banner from "./banner.vue";
import folder_list from "./folder_list.vue";
// import folders from "./folders.vue";
import files from "./files.vue";
import auth from "./auth.vue";

export default {
  name: "Home",
  components: {
    folder_list,
    files,
    auth,
  },
  mixins: [bus_common],
  data() {
    return {
      dialog2: false,
      dialog: false,
      sterm: "",
      right: null,
      files_update: null,
      folder_name: "list",
      lst_files: [], //"files_update" :folder_name="folder_name" :lst_files="lst_files",
    };
  },
  watch: {
    "$store.state.user": function () {
      //keep this
      let self = this;
      this.init();
    },
  },

  methods: {
    matchHeightIfMobile(sourceId, targetId, mobileBreakpoint = 768) {
      const isMobile = window.innerWidth <= mobileBreakpoint;

      //cont-mobile
      //rslt_card
      const sourceEl = document.getElementById(sourceId);
      const targetEl = document.getElementById(targetId);

      console.log("matchHeightIfMobile src height:" + sourceEl.offsetHeight);

      if (!sourceEl || !targetEl) {
        console.warn("One or both elements not found.");
        return;
      }

      if (isMobile) {
        //const sourceHeight = sourceEl.offsetHeight + 210;
        const sourceHeight = 247 * this.lst_files.length + 204;
        console.log("sourceHeight2: " + sourceHeight);
        targetEl.style.height = `${sourceHeight}px`;
      } else {
        const sourceHeight = 65 * this.lst_files.length + 204;
        console.log("sourceHeight2: " + sourceHeight);
        targetEl.style.height = `${sourceHeight}px`;
      }
    },
    show_help_now() {
      //this.dialog = true;
      // window.open(
      //   "https://docs.google.com/presentation/d/e/2PACX-1vSHeSraxDIrNaykPqvOrY7_Wg6BwC-bB3GKNrpzAfHDCPjA_QCeMVaNnfQtPIXyJnnFWMvkv6AcE6NU/pub?start=true&loop=true&delayms=8000",
      //   "_blank"
      // );
      window.open("/RPDFORMS2.pdf", "_blank");
    },

    search() {
      this.show_loader(true);

      var formIn = {};
      formIn.email = this.$store.state.user.email;
      formIn.token = this.$store.state.user.token;
      formIn.sterm = this.sterm;

      formIn.apiname = "search";
      var self = this;
      this.$store
        .dispatch("anyapi", formIn)
        .then((data) => {
          self.mrbreakpoint("search data");
          if (
            data &&
            typeof data === "object" &&
            typeof data.msg === "string"
          ) {
            // Looks like a response_msg from the backend
            if (data.msg.includes("start date")) {
              this.swall_it("Search Status", data.msg, "warning", null, null);
              return true;
            }
          } else {
            this.lst_files = this.mno(data);
            if (this.lst_files.length > 0) {
              this.dialog2 = true;
              setTimeout(() => {
                self.matchHeightIfMobile("cont-mobile", "rslt_card");
              }, 500);
            } else {
              this.swall_it(
                "Search Status",
                "No files were found meeting your search criteria. Please change your criteria and try again.",
                "warning",
                null,
                null
              );
            }
          }
        })
        .catch((msg) => {
          self.dialog = false;
          this.show_loader(false);
          this.swall_it("Error search", msg, "error", null, null);
        });
    },
    sendRequest() {
      alert("This button does nothing yet.");
    },
    message1() {
      alert("This button sorts the folders.");
    },

    message2() {
      alert("search opens files.vue ");
    },

    init(self) {
      console.log("debug lame");
      this.show_loader(false);
    },
  },
  mounted() {
    // fake user login
    // var user = {
    //   email: "jvonmolt@gmail.com",
    //   roles: "forms-admin",
    //   token: "myverylongandencryptedtoken",
    //   rpduserId: 42,
    //   auth: true,
    // };
    // this.$store.commit("setUser", user);
    var self = this;
    this.$nextTick(() => {
      this.init(self);
    });
  },
};
</script>
